<template>
  <v-form v-model="valid"  ref="form">
    <h2 v-if ="newLocationFlag"> Create Location</h2>
    <h2 v-else> Edit Location</h2>
    <v-text-field ref="input" :rules="[rules.required,rules.counter, rules.uniqueName, rules.whiteSpaceBeginEnd]" counter maxlength="255" label="Name" v-model="value.name"  v-on:keyup="validate()" ></v-text-field>
    <v-text-field  min="1" max="500" type="number" :rules="[rules.required, rules.aNumberHeight]" label="Height [m]" v-model.number="value.height" v-on:keyup="validate()"></v-text-field>
    <v-text-field :rules="[rules.required, rules.whiteSpaceBeginEnd]" label='Type' v-model="value.type" v-on:keyup="validate()"></v-text-field>
    <v-text-field min="1" max="25" type="number" :rules="[rules.required, rules.aNumberEirp]" label="EiRP" v-model.number="value.eirp "v-on:keyup="validate()"></v-text-field>
    <v-text-field step="0.001" min="-180" max="180" type="number" :rules="[ rules.validateCoordLong]" label="Longitude" v-model.number="value.longitude "v-on:keyup="validate()"></v-text-field>
    <v-text-field step="0.001" min="-90" max="90"type="number" :rules="[rules.validateCoordLat]" label="Latitude" v-model.number="value.latitude "v-on:keyup="validate()"></v-text-field>
<!--    <v-checkbox label="Visible" v-model="value.visibility"></v-checkbox>-->
  <v-spacer></v-spacer>
    <v-card>
    <v-textarea v-model="value.text" label="Note" counter maxlength="255"> </v-textarea>
    </v-card>
  </v-form>
</template>

<script>
import _ from "lodash"
export default {
  name: "locationForm",
  props: ["value", "types", "newLocationFlag", "locations" ],
  components: {
    typeSelect: require("./TypeSelect").default
  },
  data() {
    return {
      warn:false,
      valid: false,
      typeInput: "",
      tempHeight:this.value.height,
      tempEirp: this.value.eirp,
      tempLocations: this.locations,
      rules: {
          required: value => !!value || 'Required',
          counter: value => value.length <= 255 || 'Max 255 characters',
          aNumberHeight: value => this.isValidHeight(value) || 'Only numbers greater zero and smaller 500',
          aNumberEirp: value => this.isValidEirp(value) || 'Only numbers greater zero and smaller 25',
          uniqueName: value => this.checkforExistingName(value) || 'Location name already existing',
          whiteSpaceBeginEnd: value => this.checkForWhiteSpacesBeginEnd(value) || 'No white spaces at begin or end',
          validateCoordLat: value => this.validateCoordLat(value) || 'Not a valid Coordinate (Between -90 and 90)',
          validateCoordLong: value => this.validateCoordLong(value) || 'Not a valid Coordinate (Between -180 and 180)'
          //doubleWhiteSpaces: value => this.checkForDoubleWhiteSpaces(value) || 'No double white spaces'
        }
    }
  },
  watch: {
    value(nv) {
      this.model = nv
    }
  },
  methods: {
    validate(){

        this.valid = this.validateHeight(this.value.height)
                  && this.validateRequired(this.value.name)
                  && this.validateEirp(this.value.eirp)
                  && this.validateRequired(this.value.type)
                  && this.checkforExistingName(this.value.name)
                  && this.checkForWhiteSpacesBeginEnd(this.value.name)
              //    && this.checkForDoubleWhiteSpaces(this.value.name)
                  && this.checkForWhiteSpacesBeginEnd(this.value.type)
                //  && this.checkForDoubleWhiteSpaces(this.value.type)
                && this.validateCoordLong(this.value.longitude)
                && this.validateCoordLat(this.value.latitude)
        this.$emit('valid',[this.valid,this.warn])



     },

     isValidHeight(input){
      return this.isNumberGreaterZero(input)&&input<500
     },
     isValidEirp(input){
       if(input>14&&input<25){
         this.warn=true
       }
       else{
         this.warn=false
       }
       return this.isNumberGreaterZero(input)&&input<25
     },

     checkForWhiteSpacesBeginEnd(input){
       var whiteSpaceIndices = this.getWhiteSpace(input)
       return !(whiteSpaceIndices[0] == 1 || whiteSpaceIndices[whiteSpaceIndices.length-1] == input.length)

     },
     checkForDoubleWhiteSpaces(input){
       var whiteSpaceIndices = this.getWhiteSpace(input)

         for(var i=0; i<whiteSpaceIndices.length-1;i++) {
           if (whiteSpaceIndices[i]+1 === whiteSpaceIndices[i+1]){
             return false

           }
        }
        return true
     },
    getWhiteSpace(s) {
      var indices = [];
        for(var i=0; i<s.length;i++) {
          if (s[i] === " ") indices.push(i+1);
       }
       return indices;
     },
        validateHeight(input){
          return this.isValidHeight(input)&&!!input
        },
        validateEirp(input){
          return this.isValidEirp(input)&&!!input
        },
        validateNumberGreaterZero(input){
          return this.isNumberGreaterZero(input)&&!!input
        },
        validateNumber(input){
          return this.checkForNumber(input)&&!!input
        },

        validateCoordLat(coord){
          return(this.checkForNumber(coord)&&coord>=-90&&coord<=90)

        },
        validateCoordLong(coord){
          return(this.checkForNumber(coord)&&coord>=-180&&coord<=180)

        },

        validateRequired(input){
          return !!input
        },

      isNumberGreaterZero(input){
        return this.checkForNumber(input)&&input>0
      },

      checkForNumber(input){
        if (!isNaN(parseFloat(input)))
          return true
          else
          return false

      },
      checkforExistingName(name){
        if(name==""){
          return true
        }
        let count=0
        for(let i =0; i<this.tempLocations.length;i++){
          if(name == this.tempLocations[i].name)
            count++
        }
        if(count>1)
        return false
        else {
          return true
        }
      }


  },
  created(){
    this.validate()
    this.$nextTick(() => this.$refs.input.focus())

  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/LocationForm.vue